import { createReducer } from "@reduxjs/toolkit";
import type { IViewportDimensions } from "./landing-action-creators";
import { ILandingActions } from "./landing-actions";

export interface ILandingModel {
  viewportDimensions: IViewportDimensions;
  uploaderProcessingList: string[];
}

const landingStoreInitialState: ILandingModel = {
  viewportDimensions: {
    width: 0,
    height: 0,
    heightScreen: 0,
    isWidthResizing: false,
    isHeightResizing: false,
  },
  uploaderProcessingList: [],
};

/** Reducer */
export const landingReducer = createReducer(
  landingStoreInitialState,
  (builder) => {
    builder
      .addCase(ILandingActions.setViewportDimensions, (state, action) => {
        return {
          ...state,
          viewportDimensions: {
            ...state.viewportDimensions,
            ...action.payload,
          },
        };
      })
      .addCase(ILandingActions.setUploaderProcessing, (state, action) => {
        return {
          ...state,
          uploaderProcessingList: [
            ...state.uploaderProcessingList,
            action.payload.uploaderId,
          ],
        };
      })
      .addCase(ILandingActions.removeUploaderProcessing, (state, action) => {
        return {
          ...state,
          uploaderProcessingList: state.uploaderProcessingList.filter(
            (uploaderId) => uploaderId !== action.payload.uploaderId
          ),
        };
      });
  }
);
